
import { Component, Prop, Provide, Vue, Watch } from 'vue-property-decorator'

import SplashCom from '@/components/Splash/index.vue'
import LoadingCom from '@/components/Splash/OrigamiLoading.vue'
import HeaderCom from '@/components/Header/index.vue'
import NavCom from '@/components/NavBar/index.vue'
import ProductCom from '@/components/ProductInfo/index.vue'
import TrackCom from '@/components/TrackInfo/index.vue'
import BrandCom from '@/components/Brand/index.vue'
import FooterCom from '@/components/Footer/index.vue'
import MeterialCom from '@/components/MeterialInfo/index.vue'
import ErrorPage from '@/components/Error/index.vue'
import Diamond from '@/components/Splash/Diamond.vue'
import ChipSplash from '@/components/Splash/URLVerify.vue'

import { vlSDKRequest , vidTypes, getParams , vlModelRequest, vlMintRequest} from '@/utils/sdk'
import { hasData } from "@/utils/index";
import MeterialInfo from "../components/MeterialInfo/index.vue";

import { checkTemplete, formatterTemplate, mapTemplate } from '@/utils/DCPChecker'
import languageMapping from '@/i18n/languageMapping'
import { getLanguageDesc, getLangCode } from '@/utils/getLang'

// import { checkTemplete, formatterTemplate } from '@/utils/DCPChecker'

@Component({
  components: {
      SplashCom,
      HeaderCom,
      NavCom,
      FooterCom,
      ProductCom,
      TrackCom,
      BrandCom,
      MeterialCom,
      LoadingCom,
      Diamond,
      ErrorPage,
      ChipSplash
  },
  filters: {}
})
export default class Test extends Vue {
  /// props
  @Prop({ default: '' }) private basePath!: string

  /// data
  private data: Object = {}

  /// provide data
  @Provide() provideData: Object = {}

  // computed
  private get infos (): Array<any> {
    return Array<any>()
  }
  private loadingFinished: boolean = false
  private landingComplete: boolean = false
  private refreshLoading: boolean = false
  private requestError: any = ''
  private chipLanding: any = ''
  private showChipLanding: boolean = false
  private enableSetLang: boolean = false
  private defaultLang: any = ''
  private skuInfoExist: boolean = false

  private scroll: number = document.body.scrollTop || document.documentElement.scrollTop

  private landingInfo: any = {
    vid: "",
    cid: "",
    certUrl: "",
    explorerUrl: "",
    sku: undefined,
    activity: undefined,
    batch: undefined,
    buinfo: undefined,
    trackinfo: undefined,
    chain: "",
    language: [],
    customizedLp: false,
    displayType: ''
  }

  private customDcps: Array<any> = []
  private mintData: Array<any> = []
  private skuMapTemplate: Array<any> = []
  private activityMapTemplate: Array<any> = []
  private customMapTemplate: Array<any> = []
  private trackMapTemplate: Array<any> = []
  private currentLanguage: string = ''
  private errorMessage: string = ''

  private get navBarCount(): number  {
    var titleList = []
    if(this.landingInfo && this.landingInfo.customizedLp){
      // 品牌
      // 产品
      // 资质
      // 流转
      let {custom} = this.landingInfo.activity
      custom.textplain_013 && titleList.push({value: custom.textplain_013, code: 1})
      custom.textplain_015 && titleList.push({value: custom.textplain_015, code: 2})
      custom.textplain_011 && titleList.push({value: custom.textplain_011, code: 3})
      custom.textplain_017 && titleList.push({value: custom.textplain_017, code: 4})
      return titleList.length
    }
    if(this.landingInfo && this.landingInfo.sku){
      titleList.push({value: this.$t('app.product_info'), code: 1})
    }
    if(this.landingInfo && this.landingInfo.activity){
      titleList.push({value: this.$t('app.show_info'), code: 2})
    }
    if(this.customDcps && this.customDcps.length){
      titleList.push({value: this.$t('app.meterial_head'), code: 3})
    }
    if(this.landingInfo && this.landingInfo.trackinfo){
      titleList.push({value: this.$t('app.track_head'), code: 4})
    }
    return titleList.length
  }

  private checkEmpty(empty: any): any {
    let typeObj = Object.prototype.toString.call(empty)
    let type = (typeObj.match(/^\[\w+\s+(\w+)\]$/i) as any)[1].toLowerCase()
    if(type == "object"){
      return Object.keys(empty).length > 0 ? empty : undefined
    }
    if(type == "array"){
      let contentEmpty = (empty as Array<any>).filter((item: any) => {
        return this.checkEmpty(item)
      })
      return contentEmpty.length > 0 ? contentEmpty : undefined
    }
    return false
  }

  private enterLandingPage() {
    // console.log("enter_page")
      // return;
      this.showChipLanding = false
      this.enableSetLang = true
      if(this.defaultLang) {
        this.$i18n.locale = languageMapping(this.currentLanguage)
      }
    }

  private changeLang(item: any) {
    // console.log("item:", item)
    this.$i18n.locale = getLangCode(item)
    this.refreshLoading = true
    // return
    let query = ["sku", "activity", "batch", "track", 'buinfo']
    vlSDKRequest(query,item)
    .then((res: any)=>{
      this.refreshLoading = false
      console.log("res:",res)
      // this.displayType = res.displayType
      try {
        
        let activity = this.checkEmpty(res.jsonData[vidTypes.activity])
        let batch = this.checkEmpty(res.jsonData[hasData(res.jsonData,vidTypes.batch)])
        let paramsData = getParams()
        let sku = this.checkEmpty(res.jsonData[hasData(res.jsonData,vidTypes.sku)])
        let buinfo = this.checkEmpty(res.jsonData[hasData(res.jsonData,vidTypes.buinfo)])
        let language = res.language
        let trackinfo = this.checkEmpty(res.jsonData[hasData(res.jsonData,vidTypes.track)])

        // customizedLp for jira-8605
        let customizedLp = activity && activity.custom && activity.custom.textplain_015 && activity.custom.textplain_015.length > 0
        this.$store.state.explorerUrl = res.explorerUrl
        
        this.landingInfo = {
          vid: paramsData['vid'],
          cid: paramsData['d'] || '',
          certUrl: res.certUrl,
          explorerUrl: res.explorerUrl,
          sku: sku,
          activity: activity,
          batch: batch,
          buinfo: buinfo,
          chain: res.chain,
          language: language,
          trackinfo: trackinfo,
          customizedLp: customizedLp,
          displayType: res.displayType
        }

        vlMintRequest().then((response: any) => {
          if(response.code && response.code == 'common.success'){
            this.mintData = response.data.mintData
          }
        })

        vlModelRequest().then((response: any)=> {
        
          if(response.code && response.code == 'common.success'){

                if(sku){
                    let skuModel = response.data.modelData[vidTypes.sku]

                    let parsedSKUKeyPathList = [
                      "base.starttime",
                      "base.endtime",
                      "base.timestamp",
                      "base.mainimage",
                      "base.productname",
                      "base.description",
                      "base.productparames",
                      "custom.Productparameters",
                      "custom.Moreimages",
                      "base.files",
                      "base.skucode",
                      "custom.otherlist1589267722263",
                      "custom.otherlist1589267752295",
                    ]

                    this.skuMapTemplate = mapTemplate(skuModel,10,parsedSKUKeyPathList,sku)
                    console.log("skuMapTemplate", this.skuMapTemplate)
                }

                if(activity){
                  let customDisplay = response.data.modelData[vidTypes.activity]
                  let parsedKeyPathList = [
                    "base.starttime",
                    "base.endtime",
                    "base.timestamp",
                    "base.name",
                    "custom.loadingvideo",
                    "custom.textmultiline1585278641706",
                    "custom.otherlist1589268077752",
                    "custom.moreimages",
                    "custom.morevideos",
                    "custom.morevedios",
                    "custom.otherlist1589268342573",
                    "custom.webpages",
                    "custom.otherlist1592898286244",
                  ]
                  if(customizedLp){
                    parsedKeyPathList = parsedKeyPathList.concat([
                      "custom.textplain_011",
                      "custom.textplain_013",
                      "custom.textplain_015",
                      "custom.textplain_017",
                    ])
                  }
                  this.activityMapTemplate = mapTemplate(customDisplay,10,parsedKeyPathList,activity)
                }
              
              if(trackinfo && trackinfo.length > 0){
                let trackInfo = response.data.modelData[vidTypes.track]
                let parsedKeyPathList = [
                  "base.starttime",
                  "base.endtime",
                  "base.timestamp",
                  "base.name",
                  "base.tracktime",
                  "custom.department",
                  // "custom.textenum_000",
                  "custom.vidlist",
                  "custom.gps",
                  "custom.textmultiline1585278794156",
                  "custom.otherlist1588378662887",
                  "custom.trackvideo",
                  "custom.trackimages",
                  "custom.files",
                  "custom.template_000",
                ]
                this.trackMapTemplate = trackinfo.map((item: any) => {
                  return mapTemplate(trackInfo,10,parsedKeyPathList,item)
                })
              }
          }

          // let trackModel = response.data.modelData[vidTypes.track]
          // let checkTemp = checkTemplete(trackModel,10,[],res.jsonData[vidTypes.track][1])
          // console.log("checkTemp", checkTemp)

          // console.log("response.data", response.data)
          // console.log("sku_key", vidTypes.sku)
          // let skuModel = response.data.modelData[vidTypes.sku]
          // let skuTemp = checkTemplete(skuModel,10,[],res.jsonData[vidTypes.sku])

          // console.log("skuTemp", skuTemp)

        }).catch((err: any) => {
            console.log("model_error", err);
        })

        query = ['customDcps']
        // query,item
        vlSDKRequest(query, item).then((resp: any) => {
          let keys = vidTypes.customDcps.split(',')
          let dcps:Array<any>  = []
          keys.forEach((item: any) => {
            let dcpData = this.checkEmpty(resp.jsonData[item])
            if(dcpData){
              dcps = dcps.concat(dcpData)
            }
          })
          this.customDcps = dcps
        }).catch((err: any) => {

        })

      } catch(error) {
        console.log("parse_error", error)
      }
    }).catch((error: any) => {
        this.requestError = error.message || error
    })
  }

  /// lifecycle
  created () {
    // this.$i18n.locale = 'en-US'
    // getUrlParams
    let params = getParams()
    this.chipLanding = params['verifyResult']
    // this.chipLanding = "PASS"
    if(this.chipLanding && this.chipLanding.length > 0){
      this.showChipLanding = true
    }
  }

  mounted () {

    this.loadingFinished = false
    vlSDKRequest()
    .then((res: any)=>{
      this.landingComplete = true
      setTimeout(()=>{
          this.loadingFinished = true
      }, 300)

      console.log("res_:",res)
      try {
        
        let activity = this.checkEmpty(res.jsonData[vidTypes.activity])
        let batch = this.checkEmpty(res.jsonData[hasData(res.jsonData,vidTypes.batch)])
        let paramsData = getParams()
        let sku = this.checkEmpty(res.jsonData[hasData(res.jsonData,vidTypes.sku)])
        let buinfo = this.checkEmpty(res.jsonData[hasData(res.jsonData,vidTypes.buinfo)])
        let language = res.language
        let trackinfo = this.checkEmpty(res.jsonData[hasData(res.jsonData,vidTypes.track)])

        // customizedLp for jira-8605
        let customizedLp = activity && activity.custom && activity.custom.textplain_015 && activity.custom.textplain_015.length > 0

        this.$store.state.explorerUrl = res.explorerUrl
        let actions = (language || []).map((item: any) => {
          return { code: item, text: getLanguageDesc(item) }
        })

        this.currentLanguage = actions[0] && actions[0].code
        if (actions.length <= 0) {
          this.currentLanguage = navigator.language
        }

        if(this.enableSetLang) {
            this.$i18n.locale = languageMapping(this.currentLanguage)
        }
        if(!this.chipLanding) {
          this.$i18n.locale = languageMapping(this.currentLanguage)
        }
        this.defaultLang = language
        
        this.landingInfo = {
          vid: paramsData['vid'],
          cid: paramsData['d'] || '',
          certUrl: res.certUrl,
          explorerUrl: res.explorerUrl,
          sku: sku,
          activity: activity,
          batch: batch,
          buinfo: buinfo,
          chain: res.chain,
          language: language,
          trackinfo: trackinfo,
          customizedLp: customizedLp,
          displayType: res.displayType
        }

        this.skuInfoExist = sku && Object.keys(this.landingInfo.sku).length > 0

        vlMintRequest().then((response: any) => {
          if(response.code && response.code == 'common.success'){
            this.mintData = response.data.mintData
          }
        })

        vlModelRequest().then((response: any)=> {
        
          if(response.code && response.code == 'common.success'){

              if(sku){
                  let skuModel = response.data.modelData[vidTypes.sku]

                  let parsedSKUKeyPathList = [
                    "base.starttime",
                    "base.endtime",
                    "base.timestamp",
                    "base.mainimage",
                    "base.productname",
                    "base.description",
                    "base.productparames",
                    "custom.Productparameters",
                    "custom.Moreimages",
                    "base.files",
                    "base.skucode",
                    "custom.otherlist1589267722263",
                    "custom.otherlist1589267752295",
                  ]

                  this.skuMapTemplate = mapTemplate(skuModel,10,parsedSKUKeyPathList,sku)
              }

              if(activity){
                let customDisplay = response.data.modelData[vidTypes.activity]
                let parsedKeyPathList = [
                  "base.starttime",
                  "base.endtime",
                  "base.timestamp",
                  "base.name",
                  "custom.loadingvideo",
                  "custom.textmultiline1585278641706",
                  "custom.otherlist1589268077752",
                  "custom.moreimages",
                  "custom.morevideos",
                  "custom.morevedios",
                  "custom.otherlist1589268342573",
                  "custom.webpages",
                  "custom.otherlist1592898286244",
                ]
                if(customizedLp){
                  parsedKeyPathList = parsedKeyPathList.concat([
                    "custom.textplain_011",
                    "custom.textplain_013",
                    "custom.textplain_015",
                    "custom.textplain_017",
                  ])
                }
                this.activityMapTemplate = mapTemplate(customDisplay,10,parsedKeyPathList,activity)
              }

              if(trackinfo && trackinfo.length > 0){
              let trackInfo = response.data.modelData[vidTypes.track]
              let parsedKeyPathList = [
                "base.starttime",
                "base.endtime",
                "base.timestamp",
                "base.name",
                "base.tracktime",
                "custom.department",
                // "custom.textenum_000",
                "custom.vidlist",
                "custom.gps",
                "custom.textmultiline1585278794156",
                "custom.otherlist1588378662887",
                "custom.trackvideo",
                "custom.trackimages",
                "custom.files",
                "custom.template_000",
              ]
              this.trackMapTemplate = trackinfo.map((item: any) => {
                return mapTemplate(trackInfo,10,parsedKeyPathList,item)
              })
              // console.log("this.trackMapTemplate:", this.trackMapTemplate)
            }
          }
          // let trackModel = response.data.modelData[vidTypes.track]
          // let checkTemp = checkTemplete(trackModel,10,[],res.jsonData[vidTypes.track][1])
          // console.log("checkTemp", checkTemp)

          // console.log("response.data", response.data)
          // console.log("sku_key", vidTypes.sku)
          // let skuModel = response.data.modelData[vidTypes.sku]
          // let skuTemp = checkTemplete(skuModel,10,[],res.jsonData[vidTypes.sku])

          // console.log("skuTemp", skuTemp)

        }).catch((err: any) => {
            console.log("model_error", err);
        })

        vlSDKRequest(['customDcps']).then((resp: any) => {
          let keys = vidTypes.customDcps.split(',')
          let dcps:Array<any>  = []
          keys.forEach((item: any) => {
            let dcpData = this.checkEmpty(resp.jsonData[item])
            if(dcpData){
              dcps = dcps.concat(dcpData)
            }
          })
          this.customDcps = dcps

          vlModelRequest().then((response: any)=> {
        
            if(response.code && response.code == 'common.success'){

              if(dcps && dcps.length > 0){

                let dcpkeys = vidTypes.customDcps.split(',')
                var dcplist: Array<any> = []
                dcpkeys.forEach((item: any) => {
                    let dcpData = this.checkEmpty(resp.jsonData[item])
                    var dcpTemplete = response.data.modelData[item]
                    let parsedKeyPathList = [
                      "base.starttime",
                      "base.endtime",
                      "base.timestamp",
                      "base.name",
                      // "base.tracktime",
                      "custom.department",
                      "custom.textmultiline1584674700792",
                      "custom.otherlist1584608872847",
                      "custom.mediavideo1584691190253",
                      "custom.otherlist1584691151987",
                      "custom.otherlist1584691232291",
                      "custom.template_000",
                      "custom.textmultiline1585278794156",
                      "custom.textmultiline1584608783484",
                    ]
                    if(dcpData && dcpData.length && ((Object.keys(dcpData[0]).length))){
                      let templateModel = mapTemplate(dcpTemplete,10,parsedKeyPathList,dcpData[0])
                      dcplist.push(templateModel)
                    }
                })
                this.customMapTemplate = dcplist
                console.log("customMapTemplate", this.customMapTemplate)
              }
            }

          }).catch((err: any) => {
              console.log("model_error", err);
          })

        }).catch((err: any) => {

        })

      } catch(error) {
        console.log("parse_error", error)
      }
    }).catch((error: any) => {

      this.loadingFinished = true
      this.errorMessage = error.message || error
      this.requestError = error.message || error
    })

    window.addEventListener('scroll', () => {
      this.scroll = document.documentElement.scrollTop || document.body.scrollTop
    })
  }

  /// methods
  public methodOne (params: any): void {

  }

  /// watch methods
  @Watch('newList', { immediate: true, deep: true })
  onArrayChanged (newVal: any, oldVal: any) {

  }
}
